import './GridView.less';
import React from 'react';


export default function GridView({children, density = 'medium'}) {

    return <div className={`grid-view density-${density}`}>
        <ul>
            {
                children.map((item, index) => <li key={index}>{item}</li>)
            }
        </ul>
    </div>;
}
